// extracted by mini-css-extract-plugin
export var bigger = "circleButton-module--bigger--cd72f";
export var biggest = "circleButton-module--biggest--10cbe";
export var buttonHoverContainer = "circleButton-module--buttonHoverContainer--2cb4f";
export var buttonText = "circleButton-module--buttonText--dcb2c";
export var buttonTextRight = "circleButton-module--buttonTextRight--81343 circleButton-module--buttonText--dcb2c";
export var circleArrow = "circleButton-module--circleArrow--85cf5 circleButton-module--circleButton--afa89";
export var circleButton = "circleButton-module--circleButton--afa89";
export var circlePlay = "circleButton-module--circlePlay--bbf60 circleButton-module--circleButton--afa89";
export var circlePlus = "circleButton-module--circlePlus--9d4d4 circleButton-module--circleButton--afa89";
export var circleX = "circleButton-module--circleX--d420d circleButton-module--circleButton--afa89";
export var hasKicker = "circleButton-module--hasKicker--95835";
export var inactiveCircleArrow = "circleButton-module--inactiveCircleArrow--86a21 circleButton-module--circleArrow--85cf5 circleButton-module--circleButton--afa89";
export var kicker = "circleButton-module--kicker--dd62c";
export var prev = "circleButton-module--prev--565f7";
export var slideUp = "circleButton-module--slideUp--c0042";
export var slideUpLarge = "circleButton-module--slideUpLarge--f5b9e";
export var smallLeft = "circleButton-module--smallLeft--156c4";
export var textStyleAlt = "circleButton-module--textStyleAlt--2cee4";
export var textWhite = "circleButton-module--textWhite--72636";